import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { Jumbotron, Grid, Row, Col, Image, Button } from 'react-bootstrap';
import './Resume.css';

export default class Resume extends Component {
  componentDidMount() {
    document.title = 'Chris DiNome - Resume';
  }

  render() {
    return (
      <Grid>
        <Jumbotron>
          <h1>Christopher DiNome</h1>
          <a href="https://www.linkedin.com/in/christopher-dinome/">
            <AwesomeButtonSocial type="linkedin">LinkedIn</AwesomeButtonSocial>
          </a>

          <a href="https://github.com/GCSChris">
            <AwesomeButtonSocial type="github">GitHub</AwesomeButtonSocial>
          </a>

          <a href="mailto:chrisd1997@gmail.com">
            <AwesomeButton href="">Email Me</AwesomeButton>
          </a>

          <Link to="/projects">
            <AwesomeButton type="primary">Check out My Projects</AwesomeButton>
          </Link>

          <a href="/Christopher_DiNome.pdf">
            <AwesomeButton href="">Get a PDF of my Resume</AwesomeButton>
          </a>

          <h2>
            <strong>Education</strong>
          </h2>
          <div className="console">
            <p>Northeastern University</p>
            <p>Khoury College of Computer Sciences</p>
            <p>Bachelor of Science in Computer Science & Game Development (May 2019)</p>
            <p>GPA: 3.85/4.0</p>
          </div>

          <h2>
            <strong>Experience</strong>
          </h2>

          <div className="console">
            <p>PowerAdvocate</p>
            <p>Software Engineer II ● June 2019 - Present ● Boston, MA</p>
            <ul>
              <li>
                Develop and test new features for a J2EE web application utilizing React apps and nodejs microservices
              </li>
              <li>
                Coordinate with Product Owners and business stakeholders to manage product requirements and optimize
                development time spent on projects on a daily basis Manage and mentor co-op students, engaging in
              </li>
              <li>
                Manage and mentor co-op students, engaging in improvement feedback, setting career development goals and
                holding biweekly 1-on-1 meetings
              </li>
              <li>
                Selected by management to lead team of 3 developers completing customer-requested features, reducing
                churn
              </li>
              <li>Mocked-up and rewrote outdated legacy pages in React to modernize platform UI and UX</li>
              <li>
                Designed prototype of multi-year project to enhance searching capabilities across multiple products
              </li>
              <li>
                Organized biweekly meetings with co-op supervisors to educate new supervisors on mentoring co-op
                students
              </li>
              <li>
                Led effort to create an Intro to Web Development workshop to be held at onboarding events at local
                universities
              </li>
            </ul>
          </div>

          <div className="spacer" />

          <div className="console">
            <p>Coursedog</p>
            <p>Software Engineer Intern ● June - August 2018 ● New York, NY </p>
            <ul>
              <li>Spearheaded effort to introduce automated tests to project workflow using selenium and Jenkins</li>

              <li>
                Developed front-end mock-up displaying schedule-optimization data for a customer demo using Vue and
                ChartJS
              </li>
            </ul>
          </div>

          <div className="spacer" />

          <div className="console">
            <p>PowerAdvocate</p>
            <p>Software Development Co-op ● July - December 2017 ● Boston, MA</p>
            <ul>
              <li>Developed and tested new features for a J2EE web application hosted on a WebLogic web server</li>

              <li>Created automated Selenium tests using Jenkins, and unit/integration tests using TestNG/Mockito</li>

              <li>
                Updated platform to support internationalization in order to expand accessibility of product to French
                users
              </li>

              <li>Practiced Agile Development including daily standup, sprint planning, review, and retrospective</li>

              <li>Lead development team during Sprint Planning and technical discussions</li>

              <li>Presented completed features to stakeholders during Sprint Reviews</li>

              <li>Engaged in pair programming with other developers, both locally and remotely</li>
            </ul>
          </div>

          <h2>
            <strong>Computer Knowledge</strong>
          </h2>

          <div className="console">
            <p>Languages:</p>
            <ul>
              <li>JavaScript</li>
              <li>Java</li>
              <li>Python</li>
              <li>SQL</li>
              <li>C++</li>
              <li>C# (Unity)</li>
            </ul>

            <p>Frameworks/Tools:</p>
            <ul>
              <li>Node.js</li>
              <li>npm</li>
              <li>JUnit</li>
              <li>TestNG</li>
              <li>Jest</li>
              <li>Enzyme</li>
              <li>Playwright</li>
              <li>Selenium</li>
              <li>Spring (MVC, IoC)</li>
              <li>Gradle</li>
              <li>Hibernate</li>
              <li>AWS (S3, ECS, ECR) </li>
              <li>Elasticsearch</li>
            </ul>

            <p>Software:</p>
            <ul>
              <li>Git</li>
              <li>Subversion</li>
              <li>Jenkins</li>
              <li>IntelliJ IDEA</li>
              <li>Unity</li>
              <li>DBeaver</li>
              <li>VSCode</li>
            </ul>

            <p>Methodologies:</p>
            <ul>
              <li>Agile Development (Scrum, Continuous Flow)</li>
              <li>Pair Programming</li>
            </ul>
          </div>
        </Jumbotron>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Resume.jsx